import { Injectable, inject } from '@angular/core';
import { from,switchMap } from 'rxjs';
import { AuthService } from './auth.service';
import { EventBusService } from './EventBus.service';
import { PropertyService } from './property.service';
import { FenceDexie } from '../models/fence.model';
import { DexieDatabaseService } from './dexieIndexDB.service';
import { liveQuery } from 'dexie';
import { HttpClient } from '@angular/common/http';
import { Enterprise } from '../models/enterprise.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {
  private auth = inject(AuthService);
  private dexieService = inject(DexieDatabaseService);
  private eventBusService = inject(EventBusService);
  private propertyService = inject(PropertyService);
  private http = inject(HttpClient);



  enterprises = liveQuery(() => this.dexieService.enterprises.toArray());


  constructor() {
      const dexieService = this.dexieService;

      const initialQuery = {
        page: null,
        pageSize: null,
        searchTerm: '',
      }

      this.http.get<{items: Enterprise[]}>(`${environment.apiURL}Enterprises?query=${initialQuery}`).pipe( switchMap(data =>  {
        return from(dexieService.enterprises.bulkPut(data.items))})).subscribe();
   }

   async getAll()
   {

   }

   async save(fence: FenceDexie)
   {
    await this.dexieService.fences.add(fence);

    this.AddToDatabaseTest(fence).subscribe();
   }

   async remove(fence: FenceDexie)
   {
     await this.dexieService.fences.delete(fence.fenceID);

   }

   async update(fence: FenceDexie)
   {
    await this.dexieService.fences.update(fence.fenceID, fence);

   }

   AddToDatabaseTest(fence: FenceDexie)
   {
    return this.http.post("https://localhost:7292/api/" + 'Fence/add', fence).pipe(
    );
   }

}
